import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DaProtectNotice from '../DaProtectNotice';
import BetaBadge from '../../../BetaBadge';
import s from './HoverComponent.scss';
var HoverComponent = function (_a) {
    var svg = _a.svg, title = _a.title, context = _a.context, className = _a.className, _b = _a.isNew, isNew = _b === void 0 ? false : _b, _c = _a.showDaProtect, showDaProtect = _c === void 0 ? false : _c;
    var ai_art_generator = useFlag('ai_art_generator');
    var smallersubmit = useFlag('smallersubmit');
    return (React.createElement("div", { className: classnames(s['root'], ai_art_generator && s['ai_art_generator'], smallersubmit && s['smallersubmit'], className) },
        React.createElement("div", { className: classnames(s['container'], showDaProtect && s['da-protect-container'], isNew && s['new-container']) },
            React.createElement("div", { className: s['svg'] },
                React.createElement("img", { loading: "lazy", src: Url.staticCDNLink("eclipse/popups/hover-component/".concat(svg)), alt: "" })),
            isNew && React.createElement(BetaBadge, { badgeType: "new", variant: "medium" }),
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['context'] }, context),
            showDaProtect && React.createElement(DaProtectNotice, null))));
};
HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
//# sourceMappingURL=HoverComponent.js.map